import useClubStaffAddForm from './UseClubStaffAddForm';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import SearchMemberWithLscPopup from '@usas/ui-web/components/searches/searchMember/SearchMemberWithLscPopup';
import OrgRoleStaffRoleTreeView from '@usas/ui-web/components/tree/orgRoleTree/OrgRoleStaffRoleTreeView';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubStaffAddForm = ({ submitButtonText = 'Add Club Staff', secondaryButtonText = 'Cancel',
  staffRoleGroupId, registrationRoleGroupId, onSubmitFormCallback, onSecondaryButtonClicked,
  onIsDirtyChanged = undefined, onErrorCaught = undefined }) => {
  const {
    isDirty,
    formState,
    errorState,
    setFormData,
    handleSubmit,
    updateFormState,
    onValueTextPairChanged,
    onPersonOrgRoleChanged,
    coachTypeCodeOptions
  } = useClubStaffAddForm(onSubmitFormCallback, registrationRoleGroupId, onIsDirtyChanged, onErrorCaught);

  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <SearchMemberWithLscPopup
            label='Member Id*'
            formState={formState}
            errorState={errorState}
            setFormData={setFormData}
            onFormValueChanged={updateFormState} />
        </div>
      </div>
      <div className='row usas-extra-top-margin usas-extra-bottom-margin'>
        <div className="col-xs-12 col-sm-6 col-md-8">
          {staffRoleGroupId &&
            <OrgRoleStaffRoleTreeView
              label="Staff Role(s)*"
              name="personOrgRole"
              value={formState.personOrgRole}
              error={errorState.personOrgRole}
              message={errorState.personOrgRole}
              roleGroupId={staffRoleGroupId}
              singleSelect={false}
              selectableLeavesOnly={true}
              excludeRegistrationRolesWithoutChildren={true}
              onChange={(newValue) => { onPersonOrgRoleChanged(newValue); }} />
          }
        </div>
        {formState.hasCoachRole === true &&
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Dropdown
              label="Full Time / Part Time Coach*"
              name="coachTypeCode"
              value={formState.coachTypeCode}
              error={errorState.coachTypeCode}
              message={errorState.coachTypeCode}
              options={coachTypeCodeOptions}
              onChange={(newValue, newValueLabel, e) => { e?.target?.value && onValueTextPairChanged(newValue, 'coachTypeCode', newValueLabel, 'coachTypeCodeName'); }} />
          </div>
        }
      </div>
      {errorState.errorOnSubmitAction &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction || ''}</p>
          </div>
        </div>
      }
      {errorState.formError &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{errorState.formError || ''}</p>
          </div>
        </div>
      }
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12 usas-extra-top-margin">
          <PrimaryButton type="submit" isDisabled={isDirty === false}>{submitButtonText}</PrimaryButton>&nbsp;
          <SecondaryButton type="button" onClick={onSecondaryButtonClicked}>{secondaryButtonText}</SecondaryButton>
        </div>
      </div>
    </form>
  );
};

export default ClubStaffAddForm;